import _ from 'lodash';
import { setCrosstabDataOnSave } from './CrosstabUtils';
import { setSalesCatalystDataOnSave } from './SalesCatalystUtils';
import { setBrandCatalystDataOnSave } from './Insight360Utils';
import { setQuickReportsDataOnSave } from './QuickReportsUtils';
import sampleImage from '../images/sample-icon_blue.png';
import weightedImage from '../images/weighted-icon_blue.png';
import verticalImage from '../images/vertical-icon-down_blue.png';
import horizontalImage from '../images/horizontal-icon_blue.png';
import indexImage from '../images/index-icon_blue.png';
import {
   PREFERENCE_CROSSTAB,
   PREFERENCE_QUICKREPORTS,
   PREFERENCE_DATAHAUL,
   PREFERENCE_STORIES,
   PREFERENCE_SALES_CATALYST,
   PREFERENCE_BRAND_CATALYST,
   CROSSTAB_FEATUREID,
   QUICKREPORTS_FEATUREID,
   DATAHAUL_FEATUREID,
   STORIES_FEATUREID,
   BRAND_CATALYST_FEATUREID,
   SALES_CATALYST_FEATUREID,
  }
  from '../constants';
import { isFeaturePresent, getStudyFromStudies, filterStudyList, filterStudyList1 } from './CommonUtils';

export const preferenceData = [
  {
    mainMenu: 'Essentials',
    enabled: true,
    title: 'Essentials',
    id: 'essential-01',
    class: 'essential_icon',
    key: 'essential-nav',
    checked: false,
    subMenu: [
      {
        menuName: 'Crosstab',
        enabled: true,
        title: 'Crosstab',
        label: 'Crosstab',
        class: '',
        visible: true,
        key: 'crosstab-sub-nav',
        featureId: 1,
        tabs: [{
          tabId: 'ct_default',
          tabName: 'DEFAULTS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_ct._sw',
                row: [
                  {
                    field: 'radiobuttons',
                    label: 'Study Weighting:',
                    type: '',
                    class: '',
                    menuName: 'Crosstab',
                    dbKey: '_ct._sw',
                    defaultValue: {},
                    /* values: [{
                      key: 1,
                      label: 'Population',
                    }, {
                      key: 2,
                      label: 'Household',
                    }], */
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_ct._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column large-2 medium-2',
                  menuName: 'Crosstab',
                  dbKey: '_ct._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'column large-7 medium-7 end',
                  menuName: 'Crosstab',
                  dbKey: '_ct._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '80%',
                  },
                }],
              }, {
                visible: true,
                rowId: '_ct._be',
                row: [
                  {
                    field: 'autoUpdate',
                    label: 'Your default study will automatically update to the most recent study released',
                    type: 'autoUpdate',
                    class: '',
                    menuName: 'Crosstab',
                    dbKey: '_ct._aus',
                    inputLabel: 'YES',
                    defaultValue: false,
                    values: [{
                      label: 'YES',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      menuWidth: '15%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_ct._dv',
                row: [
                  {
                    label: 'Crosstab Editor:',
                    type: 'label',
                    class: 'column large-2 medium-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._dvl',
                    defaultValue: 'Crosstab Editor:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Crosstab Editor:',
                    type: 'dropdown',
                    class: 'column large-5 medium-5 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._dv',
                    defaultValue: 'Smart Search',
                    values: ['Smart Search', 'Dictionary Search'],
                    style: {
                      width: '100%',
                    },
                  },
                ],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_ct._be',
                row: [
                  {
                    label: 'Bases on Export:',
                    type: 'label',
                    class: 'column large-2 medium-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._bel',
                    defaultValue: 'Bases on Export:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Bases on Export:',
                    type: 'dropdown',
                    class: 'column large-5 medium-5 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._be',
                    defaultValue: 'User-Defined Only',
                    values: ['User-Defined Only', 'Standard Only', 'User-Defined & Standard', 'Current Selection'],
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_ct._su',
                row: [
                  {
                    label: 'Study Universe:',
                    type: 'label',
                    class: 'column large-2 medium-2 large-offset-2 medium-offset-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._bel',
                    defaultValue: 'Study Universe:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Study Universe:',
                    type: 'singlecheckbox',
                    class: 'column large-2 medium-2 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._su',
                    inputLabel: 'INCLUDE',
                    defaultValue: true,
                    values: [{
                      label: 'Include',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      padding: '15px',
                    },
                  },
                ],
              },
              {
                visible: true,
                rowId: '_ct._ssp',
                row: [
                  {
                    label: 'Selector Pop-up:',
                    type: 'label',
                    class: 'column large-2 medium-2 large-offset-2 medium-offset-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._bel',
                    defaultValue: 'Study Selector Pop-up:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Study Selector Pop-up:',
                    type: 'singlecheckbox',
                    class: 'column large-2 medium-2 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._ssp',
                    defaultValue: false,
                    inputLabel: 'SHOW',
                    values: [{
                      label: 'Hide',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_ct._cv',
                row: [
                  {
                    label: 'Chart View:',
                    type: 'label',
                    class: 'column large-2 medium-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._cvl',
                    defaultValue: 'Chart View:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Chart View:',
                    type: 'dropdown',
                    class: 'column large-5 medium-5 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._cv',
                    defaultValue: 'Private Eye View',
                    values: ['Private Eye View', 'Crosstab View'],
                    style: {
                      width: '100%',
                    },
                  },
                ],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_ct._el',
                row: [
                  {
                    label: 'Metrics:',
                    type: 'label',
                    class: 'column large-2 medium-2',
                    menuName: 'Crosstab',
                    dbKey: '_ct._bel',
                    defaultValue: 'Bases/Export:',
                  },
                  {
                    field: 'smartsearch',
                    label: 'Metrics:',
                    type: 'list',
                    class: 'column large-4 medium-4 end',
                    menuName: 'Crosstab',
                    dbKey: '_ct._el',
                    defaultValue: ['SAMPLE', 'WEIGHTED', 'VERTICAL', 'HORIZONTAL', 'INDEX'],
                    values: [{
                      label: 'SAMPLE',
                      value: true,
                      imageSrc: sampleImage,
                    }, {
                      label: 'WEIGHTED',
                      value: true,
                      imageSrc: weightedImage,
                    }, {
                      label: 'VERTICAL',
                      value: true,
                      imageSrc: verticalImage,
                    }, {
                      label: 'HORIZONTAL',
                      value: true,
                      imageSrc: horizontalImage,
                    }, {
                      label: 'INDEX',
                      value: true,
                      imageSrc: indexImage,
                    }],
                    showAll: true,
                    style: {
                      width: '100%',
                      padding: 0,
                    },
                  },
                ],
              },
            ],
          },
          ],
        }],
      },
      {
        menuName: 'QuickReports',
        enabled: true,
        title: 'Quick Reports',
        label: 'Quick Reports',
        class: '',
        visible: true,
        key: 'quickreports-sub-nav',
        featureId: 2,
        tabs: [{
          tabId: 'qr_default',
          tabName: 'DEFAULTS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_qr._sw',
                row: [
                  {
                    field: 'radiobuttons',
                    label: 'Study Weighting:',
                    type: '',
                    class: '',
                    menuName: 'QuickReports',
                    dbKey: '_qr._sw',
                    defaultValue: {},
                    /* values: [{
                      key: 1,
                      label: 'Population',
                    }, {
                      key: 2,
                      label: 'Household',
                    }], */
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_qr._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column large-2 medium-2',
                  menuName: 'QuickReports',
                  dbKey: '_qr._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'column large-7 medium-7 end',
                  menuName: 'QuickReports',
                  dbKey: '_qr._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '80%',
                  },
                }],
              },
              {
                visible: true,
                rowId: '_qr._be',
                row: [
                  {
                    field: 'autoUpdate',
                    label: 'Your default study will automatically update to the most recent study released',
                    type: 'autoUpdate',
                    class: '',
                    menuName: 'QuickReports',
                    dbKey: '_qr._aus',
                    inputLabel: 'YES',
                    defaultValue: false,
                    values: [{
                      label: 'YES',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      menuWidth: '15%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }],
        }],
      },
      {
        menuName: 'DataHaul',
        enabled: true,
        title: 'DataHaul',
        label: 'DataHaul',
        class: '',
        visible: true,
        key: 'datahaul-sub-nav',
        featureId: 3,
        tabs: [{
          tabId: 'dh_default',
          tabName: 'DEFAULTS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_dh._sw',
                row: [
                  {
                    field: 'radiobuttons',
                    label: 'Study Weighting:',
                    type: '',
                    class: '',
                    menuName: 'DataHaul',
                    dbKey: '_dh._sw',
                    defaultValue: {},
                    /* values: [{
                      key: 1,
                      label: 'Population',
                    }, {
                      key: 2,
                      label: 'Household',
                    }], */
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_dh._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column large-2 medium-2',
                  menuName: 'DataHaul',
                  dbKey: '_dh._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'column large-7 medium-7 end',
                  menuName: 'DataHaul',
                  dbKey: '_dh._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '80%',
                    fontWeight: 'bold',
                    color: '#4e0e28',
                  },
                }],
              },
              {
                visible: true,
                rowId: '_dh._be',
                row: [
                  {
                    field: 'autoUpdate',
                    label: 'Your default study will automatically update to the most recent study released',
                    type: 'autoUpdate',
                    class: '',
                    menuName: 'DataHaul',
                    dbKey: '_dh._aus',
                    inputLabel: 'YES',
                    defaultValue: false,
                    values: [{
                      label: 'YES',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      menuWidth: '15%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }],
        }],
      },
      {
        menuName: 'Stories',
        enabled: true,
        title: 'Stories',
        label: 'Stories',
        class: '',
        visible: false,
        key: 'stories-sub-nav',
        featureId: 4,
        tabs: [{
          tabId: 'st_default',
          tabName: 'DEFAULTS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_st._sw',
                row: [
                  {
                    field: 'radiobuttons',
                    label: 'Study Weighting:',
                    type: '',
                    class: '',
                    menuName: 'Stories',
                    dbKey: '_st._sw',
                    defaultValue: {},
                    /* values: [{
                      key: 1,
                      label: 'Population',
                    }, {
                      key: 2,
                      label: 'Household',
                    }], */
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_st._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column large-2 medium-2',
                  menuName: 'Stories',
                  dbKey: '_st._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'column large-7 medium-7 end',
                  menuName: 'Stories',
                  dbKey: '_st._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '80%',
                    fontWeight: 'bold',
                    color: '#4e0e28',
                  },
                }],
              },
              {
                visible: true,
                rowId: '_st._be',
                row: [
                  {
                    field: 'autoUpdate',
                    label: 'Your default study will automatically update to the most recent study released',
                    type: 'autoUpdate',
                    class: '',
                    menuName: 'Stories',
                    dbKey: '_st._aus',
                    inputLabel: 'YES',
                    defaultValue: false,
                    values: [{
                      label: 'YES',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      menuWidth: '15%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }],
        }],
      },
    ],
  },
  {
    mainMenu: 'Catalyst',
    enabled: true,
    title: 'Catalyst',
    id: 'catalyst-02',
    class: 'catalyst_icon',
    key: 'catalyst-nav',
    checked: false,
    subMenu: [
      {
        menuName: 'BrandCatalyst',
        enabled: true,
        title: 'Brand Catalyst',
        label: 'Brand Catalyst',
        class: '',
        visible: true,
        key: 'brand-sub-nav',
        featureId: 5,
        tabs: [{
          tabId: undefined,
          tabName: 'Smart Search',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_bc._ss',
                row: [{
                  field: 'smartSearch',
                  label: 'Smart Search:',
                  type: 'smartSearch',
                  class: 'smart-search-section',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._ss',
                  defaultValue: {},
                  options: [
                    { label: 'BASE', count: 1, itemKey: '_bc._bp' },
                  ],
                  style: {
                    width: '99%',
                  },
                }],
              },
            ],
          }],
        }, {
          tabId: 'bc_default',
          tabName: 'DEFAULTS',
          sections: [{
            session: false,
            section: [
              {
                visible: true,
                rowId: '_bc._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'width-large-new',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._bp',
                row: [{
                  label: 'Base:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._bpl',
                  defaultValue: 'Base Persona:',
                }, {
                  field: 'base',
                  label: 'BASE:',
                  type: 'dataInput',
                  class: ' column width-full-10',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._bp',
                  defaultValue: [],
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }],
        }, {
          tabId: 'bc_report_settings',
          tabName: 'REPORT SETTINGS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_bc._rfs',
                row: [{
                  label: 'Reach Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._rfsl',
                  defaultValue: 'Reach Minimum:',
                }, {
                  field: 'reachFilterSlider',
                  label: 'Reach Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._rfs',
                  defaultValue: 10,
                  minValue: 0,
                  maxValue: 100,
                  filterStartLabel: '0%',
                  filterEndLabel: '100%',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._smfs',
                row: [{
                  label: 'Sample Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._smfsl',
                  defaultValue: 'Sample Minimum:',
                }, {
                  field: 'sampleMinimumSlider',
                  label: 'Sample Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._smfs',
                  defaultValue: 60,
                  minValue: 1,
                  maxValue: 200,
                  filterStartLabel: 1,
                  filterEndLabel: 'All',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._irf',
                row: [{
                  label: 'Index Range:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._irfl',
                  defaultValue: 'Index Range:',
                }, {
                  field: 'indexRangeFilter',
                  label: 'Index',
                  type: 'rangeFilter',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_bc._irf',
                  defaultValue: {
                    selectedOption: 'Highest',
                    value: [0],
                  },
                  defaultConstant: {
                    'Greater Than': [120],
                    'Less Than': [90],
                    Equals: [130],
                    Range: [110, 120],
                    Highest: [0],
                  },
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._aus',
                row: [
                  {
                    field: 'autoUpdate',
                    label: 'Data in to graph bar will be restricted to the default metrics rule',
                    type: 'autoUpdate',
                    class: '',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._aus',
                    inputLabel: 'YES',
                    defaultValue: false,
                    values: [{
                      label: 'YES',
                      value: true,
                    }],
                    showAll: false,
                    style: {
                      width: '100%',
                      menuWidth: '15%',
                      padding: '15px',
                    },
                  },
                ],
              },
            ],
          }],
        }, {
          tabId: 'bc_study_settings',
          tabName: 'STUDY SETTINGS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_bc._sf',
                row: [{
                  label: 'Select Product:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._sfl',
                  defaultValue: 'Study Family:',
                }, {
                  field: 'selectProduct',
                  label: 'Select Product:',
                  type: 'studyFamily',
                  class: 'column width-full-10',
                  menuName: 'BrandCatalyst',
                  dbKey: '_bc._sf',
                  defaultValue: 1,
                  style: {
                    width: '80%',
                  },
                }],
              }],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._bas',
                row: [
                  {
                    label: 'Profile Attitudes:',
                    type: 'label',
                    class: 'column label-width',
                    menuName: 'profileAttitudes',
                    dbKey: '_bc._basl',
                    defaultValue: 'Profile Attitude:',
                    style: {
                      padding: '0px',
                    },
                  },
                  {
                    field: 'profileAttitudeList',
                    label: 'Profile Attitudes:',
                    type: 'profileAttitudeList',
                    class: ' column width-full-10',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._bas',
                    defaultValue: [],
                    action: {
                      name: 'getProfileAttitudeStatements',
                      type: '360BRANDS',
                    },
                    style: {
                      width: '100%',
                    },
                  },
                ],
              },
            ],

          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._ml',
                row: [
                  {
                    label: 'Media List Category:',
                    type: 'label',
                    class: 'column label-width',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._mll',
                    defaultValue: 'Media List Category:',
                    style: {
                      padding: '0px',
                    },
                  },
                  {
                    field: 'mediaFilterSearch',
                    label: 'Media List Category:',
                    type: 'filterSearch',
                    class: ' column width-full-10',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._ml',
                    defaultValue: [],
                    action: {
                      name: 'getCategorySearchList',
                      type: '360MEDIA',
                    },
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }],
          }, {
            section: [
              {
                visible: true,
                rowId: '_bc._bl',
                row: [
                  {
                    label: 'Brand List Category:',
                    type: 'label',
                    class: 'column label-width',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._bll',
                    defaultValue: 'Brand List Category:',
                    style: {
                      padding: '0px',
                    },
                  },
                  {
                    field: 'brandFilterSearch',
                    label: 'Brand List Category:',
                    type: 'filterSearch',
                    class: ' column width-full-10',
                    menuName: 'BrandCatalyst',
                    dbKey: '_bc._bl',
                    defaultValue: [],
                    action: {
                      name: 'getCategorySearchList',
                      type: '360BRANDS',
                    },
                    style: {
                      width: '100%',
                    },
                  },
                ],
              }],
          }],
        }],
      },
      {
        menuName: 'SalesCatalyst',
        enabled: true,
        title: 'Sales Catalyst',
        label: 'Sales Catalyst',
        class: '',
        visible: true,
        key: 'sales-sub-nav',
        featureId: 6,
        tabs: [{
          tabId: undefined,
          tabName: 'Smart Search',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_sc._ss',
                row: [{
                  field: 'smartSearch',
                  label: 'Smart Search:',
                  type: 'smartSearch',
                  class: 'smart-search-section',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._ss',
                  defaultValue: {},
                  options: [
                    { label: 'BASE', count: 1, itemKey: '_sc._bp' },
                    { label: 'SUB ENTITIES', count: 15, itemKey: '_sc._se' },
                  ],
                  style: {
                    width: '99%',
                  },
                }],
              },
            ],
          }],
        }, {
          tabId: 'sc_default',
          tabName: 'DEFAULTS',
          sections: [{
            session: false,
            section: [
              {
                visible: true,
                rowId: '_sc._ds',
                row: [{
                  label: 'Study on Start-up:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._dsl',
                  defaultValue: 'Study on Start-up:',
                }, {
                  field: 'studySelector',
                  label: 'Study on Start-up:',
                  type: 'studySelector',
                  class: 'width-large-new',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._ds',
                  defaultValue: -1,
                  showWeighting: true,
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._bp',
                row: [{
                  label: 'Base:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._bpl',
                  defaultValue: 'Base Persona:',
                }, {
                  field: 'base',
                  label: 'BASE:',
                  type: 'dataInput',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._bp',
                  defaultValue: [],
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }],
        }, {
          tabId: 'sc_report_settings',
          tabName: 'REPORT SETTINGS',
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_sc._rfs',
                row: [{
                  label: 'Reach Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._rfsl',
                  defaultValue: 'Reach Minimum:',
                }, {
                  field: 'reachFilterSlider',
                  label: 'Reach Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._rfs',
                  defaultValue: 10,
                  minValue: 0,
                  maxValue: 100,
                  filterStartLabel: '0%',
                  filterEndLabel: '100%',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._smfs',
                row: [{
                  label: 'Sample Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._smfsl',
                  defaultValue: 'Sample Minimum:',
                }, {
                  field: 'sampleMinimumSlider',
                  label: 'Sample Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._smfs',
                  defaultValue: 60,
                  minValue: 1,
                  maxValue: 200,
                  filterStartLabel: 1,
                  filterEndLabel: 'All',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._irf',
                row: [{
                  label: 'Index Range:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._irfl',
                  defaultValue: 'Index Range:',
                }, {
                  field: 'indexRangeFilter',
                  label: 'Index',
                  type: 'rangeFilter',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._irf',
                  defaultValue: {
                    selectedOption: 'Highest',
                    value: [0],
                  },
                  defaultConstant: {
                    'Greater Than': [120],
                    'Less Than': [90],
                    Equals: [130],
                    Range: [110, 120],
                    Highest: [0],
                  },
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._cp',
                row: [{
                  label: 'Assign Colors',
                  type: 'label',
                  class: 'column preference-color-label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._cpl',
                  defaultValue: '',
                }, {
                  label: 'Entity Color:',
                  type: 'colorPickerInputBox',
                  class: 'column color-picker-col-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._ec',
                  defaultValue: 'rgb(233,155,127)',
                  colorLabel: 'Entity Color',
                }, {
                  field: 'Target Color',
                  label: 'Target Market:',
                  type: 'colorPickerInputBox',
                  class: 'column color-picker-col-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._tmc',
                  defaultValue: 'rgb(132,201,204)',
                  colorLabel: 'Target Color',
                }, {
                  field: 'Competitor',
                  type: 'colorPickerInputBox',
                  class: 'column color-picker-competitor-one-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._cc1',
                  defaultValue: 'rgb(173,213,166)',
                  colorLabel: 'Competitor1 Color',
                  style: {
                    marginRight: '5px',
                  },
                }],
              }, {
                visible: true,
                rowId: '_sc._ct2',
                row: [{
                  field: 'Competitor',
                  type: 'colorPickerInputBox',
                  class: 'column color-picker-competitor-col-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._cc2',
                  defaultValue: 'rgb(150,185,226)',
                  colorLabel: 'Competitor2 Color',
                  style: {
                    width: '30%',
                    float: 'right',
                  },
                }],
              }, {
                visible: true,
                rowId: '_sc._ct3',
                row: [{
                  field: 'Competitor',
                  type: 'colorPickerInputBox',
                  class: 'column color-picker-competitor-col-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._cc3',
                  defaultValue: 'rgb(248, 218, 123)',
                  colorLabel: 'Competitor3 Color',
                  style: {
                    width: '30%',
                    float: 'right',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._srfsh',
                row: [{
                  label: 'Strengths default metrics',
                  type: 'label',
                  // class: 'column',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._srfsh',
                  defaultValue: 'Strengths default metrics',
                  style: {
                    height: '2px',
                    color: '#4e0e28',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    marginTop: '-10px',
                  },
                }],
              }],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._srfs',
                row: [{
                  label: 'Reach Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._srfsl',
                  defaultValue: 'Reach Minimum:',
                }, {
                  field: 'reachFilterSlider',
                  label: 'Reach Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._srfs',
                  defaultValue: 10,
                  minValue: 0,
                  maxValue: 100,
                  filterStartLabel: '0%',
                  filterEndLabel: '100%',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._ssmfs',
                row: [{
                  label: 'Sample Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._ssmfsl',
                  defaultValue: 'Sample Minimum:',
                }, {
                  field: 'sampleMinimumSlider',
                  label: 'Sample Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._ssmfs',
                  defaultValue: 60,
                  minValue: 1,
                  maxValue: 200,
                  filterStartLabel: 1,
                  filterEndLabel: 'All',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._sirf',
                row: [{
                  label: 'Index Range:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._sirfl',
                  defaultValue: 'Index Range:',
                }, {
                  field: 'indexRangeFilter',
                  label: 'Index',
                  type: 'rangeFilter',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._sirf',
                  defaultValue: {
                    selectedOption: 'Highest',
                    value: [0],
                  },
                  defaultConstant: {
                    'Greater Than': [120],
                    'Less Than': [90],
                    Equals: [130],
                    Range: [110, 120],
                    Highest: [0],
                  },
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._srfsh',
                row: [{
                  label: 'Weaknesses default metrics',
                  type: 'label',
                  // class: 'column',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._srfsh',
                  defaultValue: 'Weaknesses default metrics',
                  style: {
                    height: '2px',
                    color: '#4e0e28',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    marginTop: '-10px',
                  },
                }],
              }],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._wrfs',
                row: [{
                  label: 'Reach Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wrfsl',
                  defaultValue: 'Reach Minimum:',
                }, {
                  field: 'reachFilterSlider',
                  label: 'Reach Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wrfs',
                  defaultValue: 10,
                  minValue: 0,
                  maxValue: 100,
                  filterStartLabel: '0%',
                  filterEndLabel: '100%',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._wsmfs',
                row: [{
                  label: 'Sample Minimum:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wsmfsl',
                  defaultValue: 'Sample Minimum:',
                }, {
                  field: 'sampleMinimumSlider',
                  label: 'Sample Minimum:',
                  type: 'filterSlider',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wsmfs',
                  defaultValue: 60,
                  minValue: 1,
                  maxValue: 200,
                  filterStartLabel: 1,
                  filterEndLabel: 'All',
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }, {
            section: [
              {
                visible: true,
                rowId: '_sc._wirf',
                row: [{
                  label: 'Index Range:',
                  type: 'label',
                  class: 'column label-width',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wirfl',
                  defaultValue: 'Index Range:',
                }, {
                  field: 'indexRangeFilter',
                  label: 'Index',
                  type: 'rangeFilter',
                  class: ' column width-full-10',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._wirf',
                  defaultValue: {
                    selectedOption: 'Highest',
                    value: [0],
                  },
                  defaultConstant: {
                    'Greater Than': [120],
                    'Less Than': [90],
                    Equals: [130],
                    Range: [110, 120],
                    Highest: [0],
                  },
                  style: {
                    width: '100%',
                  },
                }],
              },
            ],
          }],
        }, {
          tabId: 'sc_study_settings',
          tabName: 'STUDY SETTINGS',
          sections: [
            {
              section: [
                {
                  visible: true,
                  rowId: '_sc._sf',
                  row: [{
                    label: 'Select Product:',
                    type: 'label',
                    class: 'column label-width',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sfl',
                    defaultValue: 'Study Family:',
                  }, {
                    field: 'selectProduct',
                    label: 'Select Product:',
                    type: 'studyFamily',
                    class: 'column width-full-10',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sf',
                    defaultValue: 1,
                    style: {
                      width: '80%',
                    },
                  }],
                }],
            }, {
              section: [
                {
                  visible: true,
                  rowId: '_sc._ml',
                  row: [
                    {
                      label: 'Media List Category:',
                      type: 'label',
                      class: 'column label-width',
                      menuName: 'SalesCatalyst',
                      dbKey: '_sc._mll',
                      defaultValue: 'Media List Category:',
                      style: {
                        padding: '0px',
                      },
                    },
                    {
                      field: 'mediaFilterSearch',
                      label: 'Media List Category:',
                      type: 'filterSearch',
                      class: ' column width-full-10',
                      menuName: 'SalesCatalyst',
                      dbKey: '_sc._ml',
                      defaultValue: [],
                      action: {
                        name: 'getCategorySearchList',
                        type: '360MEDIA',
                      },
                      style: {
                        width: '100%',
                      },
                    },
                  ],
                }],
            }, {
              section: [
                {
                  visible: true,
                  rowId: '_sc._bl',
                  row: [
                    {
                      label: 'Brand List Category:',
                      type: 'label',
                      class: 'column label-width',
                      menuName: 'SalesCatalyst',
                      dbKey: '_sc._bll',
                      defaultValue: 'Brand List Category:',
                      style: {
                        padding: '0px',
                      },
                    },
                    {
                      field: 'brandFilterSearch',
                      label: 'Brand List Category:',
                      type: 'filterSearch',
                      class: ' column width-full-10',
                      menuName: 'SalesCatalyst',
                      dbKey: '_sc._bl',
                      defaultValue: [],
                      action: {
                        name: 'getCategorySearchList',
                        type: '360BRANDS',
                      },
                      style: {
                        width: '100%',
                      },
                    },
                  ],
                },
              ],
            }, {
              section: [
                {
                  visible: true,
                  rowId: '_sc._sdb',
                  row: [{
                    label: 'Scatterplot Defaults:',
                    type: 'label',
                    class: 'column small-2',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sdl',
                    defaultValue: 'Scatterplot Defaults:',
                    style: {
                      padding: '10px 0px',
                    },
                  }, {
                    label: 'Base:',
                    type: 'label',
                    class: 'column small-2 text-right',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sdbl',
                    defaultValue: 'Base:',
                    style: {
                      padding: '10px 0px',
                    },
                  }, {
                    field: 'selectDropdown',
                    label: 'Select Universe/Base or Target:',
                    type: 'selectDropdown',
                    class: 'column small-8 padding-0',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sdb',
                    placeholder: 'Select Universe/Base or Target',
                    defaultValue: 'Universe/Base',
                    values: ['Universe/Base', 'Target'],
                  }],
                }, {
                  visible: true,
                  rowId: '_sc._sdc',
                  row: [{
                    label: 'Category:',
                    type: 'label',
                    class: 'column small-2 text-right small-offset-2',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sdcl',
                    defaultValue: 'Category:',
                    style: {
                      padding: '10px 0px',
                    },
                  }, {
                    field: 'selectDropdown',
                    label: 'Select List:',
                    type: 'selectDropdown',
                    class: 'column small-8 padding-0',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._sdc',
                    placeholder: 'Select Category',
                    defaultValue: [],
                    action: {
                      name: 'getActivitiesTemplateList',
                      type: undefined,
                      labelKey: 'templateName',
                      valueKey: 'templateName',
                      storeKey: 'activitiesTemplateList',
                    },
                  }],
                }],
            },
          ],
        }, {
          tabId: 'sc_package',
          tabName: 'PACKAGE',
          preferencesVisible: false,
          sections: [{
            section: [
              {
                visible: true,
                rowId: '_sc._sl1',
                row: [
                  {
                    label: 'Select List:',
                    type: 'label',
                    class: 'column small-6',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._stll',
                    defaultValue: 'Select List:',
                    style: {
                      padding: '0px',
                    },
                  },
                  {
                    label: 'Save List:',
                    type: 'label',
                    class: 'column small-6',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._svll',
                    defaultValue: 'Save List:',
                    style: {
                      padding: '0px',
                    },
                  },
                ],
              }, {
                visible: true,
                rowId: '_sc._sl2',
                row: [
                  {
                    field: 'selectDropdown',
                    label: 'Select List:',
                    type: 'selectDropdown',
                    class: 'column small-6',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._stl',
                    updateKey: '_sc._se',
                    updateKeySl: '_sc._svl',
                    placeholder: 'Please Select List',
                    defaultValue: {},
                    filterSearch: false,
                    action: {
                      name: 'scActionGetMethod',
                      type: 'subentities',
                      labelKey: 'templateName',
                      valueKey: 'templateId',
                    },
                    updateAction: {
                      name: 'scLoadTemplate',
                      type: 'subentities',
                    },
                  },
                  {
                    field: 'saveList',
                    label: 'Save List:',
                    type: 'inlineEdit',
                    class: 'column small-6',
                    menuName: 'SalesCatalyst',
                    dbKey: '_sc._svl',
                    updateKey: '_sc._stl',
                    dataElKey: '_sc._se',
                    defaultValue: '',
                    editMode: true,
                    labelLength: 128,
                    inputClass: 'preferences-cmn-inline-edit',
                    inputPlaceholder: 'Enter List Name',
                  },
                ],
              }, {
                visible: true,
                rowId: '_sc._se',
                row: [{
                  field: 'subEntities',
                  label: 'Sub Entitites:',
                  type: 'dataInput',
                  class: 'column small-10 small-offset-1 preference-input-group',
                  menuName: 'SalesCatalyst',
                  dbKey: '_sc._se',
                  updateKey: '_sc._stl',
                  updateKeySl: '_sc._svl',
                  defaultValue: [],
                  textElements: {
                    helperText: 'Add up to 15 sub-entities',
                    clearAllText: 'CLEAR LIST',
                  },
                }],
              },
            ],
          }],
        }],
      },
    ],
  },
  /* {
    mainMenu: 'Edge',
    enabled: true,
    title: 'Edge',
    id: 'edge-03',
    class: 'edge_icon',
    key: 'edge-nav',
    checked: false,
    subMenu: [
      {
        menuName: 'InstantEdge',
        enabled: true,
        title: 'Instant Edge',
        label: 'Instant Edge',
        class: '',
        visible: true,
        key: 'instantedge-sub-nav',
        featureId: 7,
        sections: [{
          section: [
          ],
        }],
      },
    ],
  }, */
];

export const isStudyAvailable = (studyType, moduleType, studies, permissions) => {
  let studyData = [];
  if (studies) {
    switch (moduleType) {
      case PREFERENCE_CROSSTAB: {
        if (isFeaturePresent(CROSSTAB_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, CROSSTAB_FEATUREID);
        }
        break;
      }
      case PREFERENCE_QUICKREPORTS: {
        if (isFeaturePresent(QUICKREPORTS_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, QUICKREPORTS_FEATUREID);
        }
        break;
      }
      case PREFERENCE_DATAHAUL: {
        if (isFeaturePresent(DATAHAUL_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, DATAHAUL_FEATUREID);
        }
        break;
      }
      case PREFERENCE_STORIES: {
        if (isFeaturePresent(STORIES_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, STORIES_FEATUREID);
        }
        break;
      }
      case PREFERENCE_SALES_CATALYST: {
        if (isFeaturePresent(SALES_CATALYST_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, SALES_CATALYST_FEATUREID);
        }
        break;
      }
      case PREFERENCE_BRAND_CATALYST: {
        if (isFeaturePresent(BRAND_CATALYST_FEATUREID, permissions)) {
          studyData = filterStudyList(studies, BRAND_CATALYST_FEATUREID);
        }
        break;
      }
      default: break;
    }
  }
  if (studyData && studyData.length > 0) {
    return getStudyFromStudies(studyData, studyType);
  }
  return false;
};

export const getClonedPrefrences = preferences => {
  const clonedPrefernces = {};
  preferenceData.map(mainMenu => {
    return mainMenu.subMenu.map(subMenu => {
      return subMenu.tabs && subMenu.tabs.map(tab => {
        return tab.sections && tab.sections.map(section => {
          return section.section && section.section.map(row => {
            return row.row && row.row.map(field => {
              if (field.dbKey !== undefined) {
                const keys = field.dbKey.split('.');
                const parentKey = keys[0];
                const childKey = keys[1];
                if (!_.has(clonedPrefernces, parentKey)) {
                  clonedPrefernces[parentKey] = {};
                }
                if (preferences[parentKey] !== undefined &&
                  preferences[parentKey][childKey] !== undefined) {
                  if (typeof preferences[parentKey][childKey] !== typeof field.defaultValue) {
                    if (childKey !== '_sw') {
                      clonedPrefernces[parentKey][childKey] = field.defaultValue;
                    } else {
                      clonedPrefernces[parentKey][childKey] = preferences[parentKey][childKey];
                    }
                  } else {
                    const originalValue = _.cloneDeep(preferences[parentKey][childKey]);
                    if (field.defaultValue && typeof field.defaultValue !== 'boolean') {
                      if (field.values && typeof field.values === 'object' && field.values.length > 0) {
                        const valuePresent = field.values.some(element => {
                          if (typeof element === 'string') {
                            return element === originalValue;
                          }
                          if (originalValue && typeof originalValue === 'object' && originalValue.length > 1) {
                            return originalValue.includes(element.label);
                          }
                          return element.label === originalValue;
                        });
                        if (valuePresent) {
                          clonedPrefernces[parentKey][childKey] = preferences[parentKey][childKey];
                        } else {
                          clonedPrefernces[parentKey][childKey] = field.defaultValue;
                        }
                      } else if (field.values && typeof field.values === 'object' && field.values.length === 0) {
                        clonedPrefernces[parentKey][childKey] = field.defaultValue;
                      } else {
                        clonedPrefernces[parentKey][childKey] = preferences[parentKey][childKey];
                      }
                    } else {
                      clonedPrefernces[parentKey][childKey] = preferences[parentKey][childKey];
                    }
                  }
                } else {
                  clonedPrefernces[parentKey][childKey] = field.defaultValue;
                }
                return clonedPrefernces;
              }
              return null;
            });
          });
        });
      });
    });
  });
  return clonedPrefernces;
};

export const setModuleDataOnSave = preferencesObj => (dispatch, getState) => {
  const preferences = _.cloneDeep(preferencesObj);
  const { userDetail } = getState();
  const { permissions } = userDetail;
  if (typeof (preferences._ct.modified) === 'undefined' && typeof (preferences._sc.modified) === 'undefined'
    && typeof (preferences._qr.modified) === 'undefined' && typeof (preferences._bc.modified) === 'undefined') {
    preferences._ct.modified = true;
    preferences._sc.modified = true;
    preferences._bc.modified = true;
    preferences._qr.modified = true;
    preferences._st.modified = true;
    preferences._dh.modified = true;
  }
  if (isFeaturePresent(CROSSTAB_FEATUREID, permissions) ||
    isFeaturePresent(DATAHAUL_FEATUREID, permissions) ||
    isFeaturePresent(STORIES_FEATUREID, permissions)) {
    if ((preferences._ct && preferences._ct.modified) ||
      (preferences._dh && preferences._dh.modified) ||
      (preferences._st && preferences._st.modified)) {
      setCrosstabDataOnSave(preferences, dispatch, getState);
    }
  }
  if (isFeaturePresent(QUICKREPORTS_FEATUREID, permissions)) {
    if (preferences._qr && preferences._qr.modified) {
      setQuickReportsDataOnSave(preferences, dispatch, getState);
    }
  }
  if (isFeaturePresent(SALES_CATALYST_FEATUREID, permissions)) {
    if (preferences._sc && preferences._sc.modified) {
      setSalesCatalystDataOnSave(preferences._sc, dispatch, getState);
    }
  }
  if (isFeaturePresent(BRAND_CATALYST_FEATUREID, permissions)) {
    if (preferences._bc && preferences._bc.modified) {
      setBrandCatalystDataOnSave(preferences._bc, dispatch, getState);
    }
  }
};

export const createWarningMessageObj = (tab, section, title, message, type) => {
  const warningData = {
    tab,
    section,
    title,
    message: type === undefined ? message : undefined,
  };
  return warningData;
};
